import {MEETING_STATUS_CONFIRMED} from '../constants';

export function isMeetingConfirmed(meeting) {
    if (!meeting) return false;
    return !!(meeting.invited?.some(meeting => meeting.state == MEETING_STATUS_CONFIRMED) || meeting.state == MEETING_STATUS_CONFIRMED);
}
